// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"e038fd9a","265":"e038fd9a","615":"e038fd9a","629":"9677c181","682":"e038fd9a","953":"e038fd9a","978":"9527d92c"}[chunkId] + ".chunk.css";
};